import { useResizeObserver } from '../../internal/hooks/container-queries';
import { useCallback } from 'react';
var extractHeight = function (rect) { return rect === null || rect === void 0 ? void 0 : rect.borderBoxSize[0].blockSize; };
export function useObservedElement(selector) {
    var _a;
    var getElement = useCallback(function () { return document.querySelector(selector); }, [selector]);
    return (_a = useResizeObserver(getElement, extractHeight)) !== null && _a !== void 0 ? _a : 0;
}
//# sourceMappingURL=use-observed-element.js.map